var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bolt_svg2__a",
    x1: -4.93,
    x2: 166.15,
    y1: 40.73,
    y2: 174.12,
    gradientTransform: "matrix(1 0 0 -1 0 200)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M156.4 68.09a3.34 3.34 0 0 0-3.02-1.93h-39.5l38.99-61.54c.65-1.03.69-2.33.1-3.39a3.34 3.34 0 0 0-2.92-1.73H96.72c-1.26 0-2.42.71-2.98 1.84l-50 100c-.52 1.03-.46 2.26.15 3.24s1.68 1.58 2.84 1.58h34.28l-37.35 88.71a3.34 3.34 0 0 0 1.33 4.14c.54.33 1.14.49 1.74.49.96 0 1.9-.41 2.55-1.18L155.95 71.65c.84-.99 1.02-2.38.47-3.56z",
    style: {
      fill: "url(#bolt_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgBolt;